import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  ImgCover,
  ImgCoverTitle,
  ImgCoverSubTitle,
  CoverWrapper
} from '../HelperComponents/StyledComponents';

import {
  stripUrlQueryParams,
} from '../../helpers';

import TuesdayCollectiveDefaultImg from '../../images/tuesday-collective-default.jpg';
// import { fetchPlayerSong } from '../../actions/PlayerActions';

export class CoverComponent extends Component {
  static propTypes = {
    cover: PropTypes.object,
    dispatch: PropTypes.func
  };

  render() {
    const coverData = this.props.cover;

    let album = coverData.album_cover || {
      url: TuesdayCollectiveDefaultImg
    };
    album = Object.assign(album, {
      album_style: coverData.album_subtitle
    });

    const albumUrl = stripUrlQueryParams(album.url);

    const closeFilter2 = () => {
      var delets = document.querySelectorAll('span.tag.is-delete'); 
      for (let i = 0; i < delets.length; ++i) {
        delets[i].click();
      };
    };

    return (
      <Fragment>
        <CoverWrapper className="card" style={{ backgroundColor: 'transparent' }}>
            <div className="card-image" onClick={closeFilter2}>
              <Link
                to={`/album/${this.props.cover.ID}`}
                className="has-text-white"
                aria-label={`Album: ${this.props.cover.title}`}
              >
                <figure className="image is-square" >
                    <ImgCover src={albumUrl || TuesdayCollectiveDefaultImg} alt={''} className="img-cover" />
                  <div className="play-button" />
                </figure>
              </Link>
            </div>
          <div className="card-content" style={{ padding: '0.5rem 0' }}>
              <div className="content">
                <ImgCoverTitle>
                  <Link 
                  to={`/album/${this.props.cover.ID}`} 
                  className="has-text-white">
                  {this.props.cover.title}
                  </Link>
                </ImgCoverTitle>
                <ImgCoverSubTitle className="is-capitalized">{this.props.cover.album_subtitle}</ImgCoverSubTitle>
              </div>
            </div>
        </CoverWrapper>
      </Fragment>
    );
  }
}

export const Cover = connect()(CoverComponent);




// WEBPACK FOOTER //
// ./src/components/Cover/Cover.js